import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { apiService } from '../../services/api';
import Header from '../../components/customer/Header';
import styles from './ProductDetail.module.css';

const ProductDetail = () => {
  const { slug } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const { addToCart, cartItems, updateQuantity, removeFromCart, fetchCartItems } = useCart();
  const [quantity, setQuantity] = useState(0);
  const [email, setEmail] = useState('');
  const [showEmailInput, setShowEmailInput] = useState(false);
  const [mainImage, setMainImage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProduct = async () => {
      setLoading(true);
      const data = await apiService.getProductBySlug(slug);
      setProduct(data);
      console.log('Datos de la pantalla detail',data)
      setLoading(false);
    };
    fetchProduct();
  }, [slug]);

  useEffect(() => {
    const savedEmail = localStorage.getItem('guest_email');
    if (savedEmail) setEmail(savedEmail);
  }, []);

  useEffect(() => {
    if (product && cartItems) {
      const cartItem = cartItems.find(item => item.id === product.id);
      setQuantity(cartItem ? cartItem.quantity : 0);
    }
  }, [cartItems, product]);

  const handleAddToCart = async () => {
    if (!email) {
      setShowEmailInput(true);
      return;
    }
    localStorage.setItem('guest_email', email);
    await addToCart(product, 1, email);
    await fetchCartItems();
    setShowEmailInput(false);
  };

  const handleIncrease = async () => {
    await updateQuantity(product.id, quantity + 1, email);
    await fetchCartItems();
  };

  const handleDecrease = async () => {
    if (quantity > 1) {
      await updateQuantity(product.id, quantity - 1, email);
      await fetchCartItems();
    } else {
      await removeFromCart(product.id, email);
      await fetchCartItems();
    }
  };

  const handleBuyNow = async () => {
    if (quantity === 0) {
      await addToCart(product, 1, email);
      await fetchCartItems();
    }
    navigate('/Checkout', { state: { directProduct: { ...product, quantity: 1 } } });
  }

  if (loading) {
    return (
      <>
        <Header />
        <div className={styles.loading}>Cargando...</div>
      </>
    );
  }

  if (!product) {
    return (
      <>
        <Header />
        <div className={styles.notFound}>Producto no encontrado</div>
      </>
    );
  }

  const primaryImageUrl = mainImage || product.product_images?.find(img => img.is_primary)?.cloudflare_url
    || product.product_images?.[0]?.cloudflare_url
    || '/placeholder-image.jpg';

  return (
    <>
      <Header />
      <div className={styles.amazonContainer}>
        <div className={styles.leftColumn}>
          <div className={styles.imageGallery}>
            <img src={primaryImageUrl} alt={product.name} className={styles.mainImage} />
            <div className={styles.thumbnailList}>
              {product.product_images?.map((img, idx) => (
                <img
                  key={img.id || idx}
                  src={img.cloudflare_url}
                  alt={img.alt_text || product.name}
                  className={styles.thumbnail}
                  onClick={() => setMainImage(img.cloudflare_url)}
                />
              ))}
            </div>
          </div>
        </div>
        <div className={styles.detailsColumn}>
          <h1 className={styles.name}>{product.name}</h1>
          <div className={styles.ratingRow}>
            {/* Puedes agregar estrellas y número de reviews aquí */}
          </div>
          <div className={styles.badges}>
            {product.is_prime && <span className={styles.prime}>Prime</span>}
          </div>
          <div className={styles.description}>
            <h2>Sobre este producto</h2>
            <p>{product.description}</p>
          </div>
          <div className={styles.detailsTable}>
            <div><strong>Marca:</strong> {product.brand || 'N/A'}</div>
            <div><strong>Stock:</strong> {product.stock_quantity}</div>
            {/* Atributos personalizados */}
            {Array.isArray(product.product_attribute_values) && product.product_attribute_values.length > 0 && (
              <>
                {product.product_attribute_values.map(attrVal => (
                  <div key={attrVal.id} className={styles.customAttrRow}>
                    <strong>{attrVal.product_attributes?.name || 'Atributo'}:</strong> {attrVal.value}
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
        <div className={styles.rightColumn}>
          <div className={styles.buyBox}>
            <div className={styles.priceBuyBox}>${product.price.toFixed(2)}</div>
            <div className={styles.stockBuyBox}>
              {product.stock_quantity > 0 ? 'Disponible' : 'Agotado'}
            </div>
            <div className={styles.cartControls}>
              {showEmailInput ? (
                <div className={styles.emailInputContainer}>
                  <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="Ingresa tu email"
                    className={styles.emailInput}
                  />
                  <button
                    className={styles.addToCart}
                    onClick={handleAddToCart}
                    disabled={!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)}
                  >
                    Confirmar
                  </button>
                </div>
              ) : quantity > 0 ? (
                <div className={styles.cartQuantityControls}>
                  <button
                    className={styles.decreaseBtn}
                    onClick={handleDecrease}
                    disabled={quantity === 0}
                  >−</button>
                  <span className={styles.quantity}>{quantity}</span>
                  <button
                    className={styles.increaseBtn}
                    onClick={handleIncrease}
                    disabled={quantity >= product.stock_quantity}
                  >+</button>
                </div>
              ) : (
                <button
                  className={styles.addToCart}
                  onClick={handleAddToCart}
                  disabled={product.stock_quantity === 0}
                >
                  Agregar al carrito
                </button>
              )}
            </div>
            <div className={styles.buyNowBox}>
              <button className={styles.buyNowBtn} onClick={() => handleBuyNow()}>Comprar ahora</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductDetail;